import { render, staticRenderFns } from "./SetAutoSync.vue?vue&type=template&id=3fca38a2&"
import script from "./SetAutoSync.vue?vue&type=script&lang=js&"
export * from "./SetAutoSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports